import { type ReactNode } from 'react'
import { ElementSidebar } from './ElementSidebar'
import { useElementMailStore } from '../../store'

interface ElementAppShellProps {
  children: ReactNode
}

export function ElementAppShell({ children }: ElementAppShellProps) {
  const {
    folderList,
    activeFolder,
    setActiveElementFolder,
    loadElementMessageList
  } = useElementMailStore()

  async function handleFolderSelection(selectedFolderName: string): Promise<void> {
    setActiveElementFolder(selectedFolderName)
    await loadElementMessageList({ folder: selectedFolderName, page: 1 })
  }

  return (
    <div className="element-app-shell">
      <ElementSidebar
        folderList={folderList}
        activeFolder={activeFolder}
        onFolderSelect={handleFolderSelection}
      />
      <main className="element-main-content">
        {children}
      </main>
    </div>
  )
}
